import { CheckIcon, CloseIcon } from '@chakra-ui/icons';

export const returnIcon = (active: boolean) => {
  return active ? <CheckIcon color={'green.400'} /> : <CloseIcon color={'red.400'} />;
};
